var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationOopsError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 482.168,
    height: 256.612,
    viewBox: "0 0 482.168 256.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.ac,.b{fill:#d9e9fe;}.b{opacity:0.393;}.c{fill:#acd29a;opacity:0.359;}.d{fill:#2b478b;}.e{fill:url(#a);}.f{fill:#163560;}.g{fill:url(#b);}.h{fill:#1c468a;}.i{fill:#e2915a;}.j{fill:#ffb27d;}.k{fill:url(#c);}.l{fill:#739af0;}.m{fill:#ee9849;}.n{fill:#f8d2a1;}.o{fill:#4a75cb;}.p{fill:#efa471;}.q{fill:#0c95a3;}.r{fill:#0da3b2;}.s{fill:#45449f;}.t{fill:#3662c1;}.u{fill:#0b0754;}.v{fill:#a0bdff;}.w{fill:#d2dceb;}.x{fill:#6d89d0;}.y{fill:#e6e6e6;}.z{fill:#ebebeb;}.aa{fill:#f0f0f0;}.ab{fill:#e0e0e0;}.ac{opacity:0.2;}.ad{fill:#adadad;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.148,
    y1: -0.041,
    x2: 1.942,
    y2: -0.041,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#232c3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#172339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -6.635,
    y1: -0.966,
    x2: -5.313,
    y2: -0.966,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.608 237.011)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 167.668,
    cy: 9.801,
    rx: 167.668,
    ry: 9.801,
    transform: "translate(0 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.366 38.366)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2065.493,1520.179l-305.832-.1s-.188-.22-.531-.645c-.135-.17-.3-.373-.479-.606-.483-.619-1.12-1.461-1.866-2.511-.291-.407-.6-.847-.92-1.315-1.435-2.094-3.153-4.79-4.931-8q-.663-1.2-1.333-2.491c-.018-.036-.038-.071-.056-.107-.147-.282-.292-.57-.441-.86v0q-.325-.644-.649-1.308c-.792-1.627-1.577-3.349-2.332-5.159-.048-.115-.095-.227-.141-.341q-.789-1.9-1.528-3.931c-.042-.112-.083-.227-.125-.341-.057-.159-.113-.32-.171-.481-.049-.137-.1-.275-.144-.412q-.181-.515-.354-1.037l-.034-.1c-.034-.1-.065-.195-.1-.292q-.541-1.645-1.033-3.356-.237-.818-.457-1.652c-.642-2.4-1.2-4.9-1.641-7.476q-.476-2.77-.77-5.662c0-.03-.005-.062-.008-.092a76.44,76.44,0,0,1-.367-8.686c.194-13.012,3.8-27.355,13.49-42.018a112.078,112.078,0,0,1,15.132-18.611,79.82,79.82,0,0,1,6.549-5.732c10.936-8.532,22.067-12.192,32.807-12.344.434,0,.867-.007,1.3,0,12.682.154,24.782,5.146,35.319,12.707,6.748,4.842,21.3,4.1,37.774-7.944q3.231-2.362,6.548-5.321a116.568,116.568,0,0,0,16.563-18.673q.51-.7,1.017-1.427,3.9-5.533,7.718-12.074c.049-.086.1-.17.148-.252q1.2-2.039,2.517-3.933c19.916-28.643,60.13-33.276,92.552-18.872q3.334,1.48,6.55,3.229a84.994,84.994,0,0,1,20.648,15.643q1.835,1.9,3.544,3.933a75.912,75.912,0,0,1,8.463,12.326q.387.708.763,1.427c8.3,15.925,11.317,35.774,5.782,58.97C2043.193,1471.363,2088.659,1473.075,2065.493,1520.179Z",
    transform: "translate(-1739.058 -1320.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M983.1,931.592c-1.37-5.315-10.633-1.2-18.261,3.261q-.534-.844-1.1-1.67c5.461-3.388,13.13-9.022,10.211-12.451-2.884-3.387-8.519,4.282-12.044,9.938-9.443-12.256-23.446-20.978-23.446-20.978s58.437-48.554,14.77-74.17-76.842,64.516-76.842,64.516-29.839-27.631-58.33-17.427c-29.259,10.48-10.974,29.9-36.383,35.154-2.992-11.454-8.522-27.608-16.084-28.555-9.986-1.251-5.784,11.248,9.39,29.507-2.941.264-6.292.4-10.121.388-40.753-.121-30.3,29.221-30.3,29.221l235.624.544a29.031,29.031,0,0,0-2.369-8.476c8.071-1.268,16.573-3.8,15.283-8.8",
    transform: "translate(-733.356 -749.719)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(244.534 80.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M548.348,300.876l29.687,64.167,3.346-.011L555.71,296.708Z",
    transform: "translate(-409.331 -207.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M510.826,302.687l-29.687,62.8-3.346-.011,25.671-64.21Z",
    transform: "translate(-402.516 -208.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M427.345,356.324l-15.09,13.2-17.788-12.519s6.055-2.031,16.436.734l10.624-8.928Z",
    transform: "translate(-394.467 -212.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M517.176,276.507s-33.349,17.094-45.131,22.208-51.866,45.254-51.866,45.254,5.131,10.45,7.7,8.614c22.633-16.182,43.484-30.661,56.883-35.713,26.532-10,33.927-12.179,40.724-20.056C525.483,296.816,521.5,287.35,517.176,276.507Z",
    transform: "translate(-396.951 -205.836)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.167 66.331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M467.241,349.388l-4.349,19.573-21.749.435s3.68-5.219,13.684-9.134l3.28-13.483Z",
    transform: "translate(-441.143 -278.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M521.745,271.7s-31.021,3.346-42.33,9.436-20.31,61.933-20.31,61.933,8.783,4.768,9.871,1.807a406.638,406.638,0,0,1,18.5-42.6c11.145-2.036,36.962,10.528,55.622-7.851C543.1,294.432,526.964,282.142,521.745,271.7Z",
    transform: "translate(-442.878 -271.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.077)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M585.857,229.018a41.338,41.338,0,0,0-3.652,8.354l-12.76-1.178s6.588-9.982,6.084-16.035Z",
    transform: "translate(-569.446 -200.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M583.36,206.949c-.724-.192-3.451-.943-4-.718-.765.312.125,1.315-.414,1.928-.872.992-2.617,1.013-3.742,1.615a7.442,7.442,0,0,0-3.026,2.785c-1.039,1.826,2.746,5.9,3.337,8.955,1.24,6.389,9.315,7.334,15.876,5.378a11.383,11.383,0,0,0,5.782-4.855c1.5-2.4.656-6.425-.6-8.819a11.2,11.2,0,0,0-3.557-3.576c-1.183-.815-1.51-4.208-2.935-4.448C590.076,205.2,584.991,207.382,583.36,206.949Z",
    transform: "translate(-569.692 -198.948)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M603,223.433c.014.013-.22-1.071,1.631-2.814,6.121-5.764-.426-17.038-7.1-19-3.413-1-5.594.054-6.819-3.337.088.243-1.38.865-1.524.988a2.643,2.643,0,0,0-1.208,2.274c-.113,4.927,4.3,9.515,7.633,12.618,1.5,1.4-2.192.433-3.68.717-.969.186-3.483,2.84-4.022,3.242,1.4,1.742,2.644.169,4.532,1.011,1.743.778.639,3-.987,3.259a3.413,3.413,0,0,1-3.541-1.253c-1.154.626-1.338,4.363-2.244,5.341,1.25.687,8.544,1.969,10.256,1.949A7.3,7.3,0,0,0,603,223.433Z",
    transform: "translate(-571.014 -198.28)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M581.48,231.963c2.675,29.84-31.684,58.45-31.684,58.45s-22.435.844-21.357-22.729c0,0,1.745-4.287,15.634-16.873,9.279-8.41,15.8-20.96,22.328-20.71C584.234,230.784,581.48,231.963,581.48,231.963Z",
    transform: "translate(-407.404 -201.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M494.91,292.05s20.692,7.718,48.269-2.743S578.279,230,578.279,230l3.156,1.6s-3.072,53.9-39.38,65.615c-27.757,8.955-47.144-1.71-47.144-1.71Z",
    transform: "translate(-404.169 -201.344)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.419 30.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M583.481,264.358s3.3,11.449,3.487,17.156-2.255,25.08-2.255,25.08l5.255.666s4.671-23.092,4.781-30.628-4.236-19.744-4.236-19.744Z",
    transform: "translate(-575.143 -234.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M582.261,262.431c3.816,16.672,2.234,39.017,2.234,39.017l5.7.363c6.252-13.079,5.667-42.058,2.361-54.25-1.942-7.163-3.087-14.386-7.934-15.5-3.03-.7-9.263,1.521-10.1,4.516C572.715,243.077,580.389,254.253,582.261,262.431Z",
    transform: "translate(-574.252 -231.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M582.09,314.569c-1.258,2.4-1.828,4.154-1.088,4.759.512.417,1.334-1.91,2.329-2.74a7.194,7.194,0,0,1-.289,4.306c-.7,1.728-.641,3.205.672,3.333s3.449.041,3.924-1.048,1.555-5.626,2.138-7.137-.191-3.246.032-4.111-3.878-2.313-3.878-2.313c-.225.348-1.488,2.071-1.488,2.071a13.307,13.307,0,0,1-1.432,1.507A5.075,5.075,0,0,0,582.09,314.569Z",
    transform: "translate(-574.872 -239.436)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.466 73.338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.738 2.908)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.847 2.135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M306.988,217.361a27.748,27.748,0,0,1,3.912-6.43c2.523-3.029,6.285-8.073,6.285-8.073s-1.835,3.59-4.326,7.646A31.015,31.015,0,0,1,306.988,217.361Z",
    transform: "translate(-301.534 -196.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M309.876,210.763a16.074,16.074,0,0,0,4.471-6.841c1.678-4.646,3.206-8.183,3.206-8.183a65.654,65.654,0,0,0-5.181,8.776C310.815,208.108,309.876,210.763,309.876,210.763Z",
    transform: "translate(-301.813 -195.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M307.135,216.424a58.589,58.589,0,0,0,1.748-9.555c.287-4.242.255-6.906.255-6.906s-1.843,7.7-2.4,10.965A10.584,10.584,0,0,0,307.135,216.424Z",
    transform: "translate(-301.494 -196.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.492,220.125a30.883,30.883,0,0,0-1.071-10.368,32.544,32.544,0,0,1-1.622-8,33.02,33.02,0,0,0,.138,9.544A63.218,63.218,0,0,0,305.492,220.125Z",
    transform: "translate(-301.102 -196.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M306.313,219.986s3.887-3.32,5.852-4.1a23.35,23.35,0,0,0,4.7-3.057s-3.378,4.324-5.263,5.181S306.313,219.986,306.313,219.986Z",
    transform: "translate(-301.469 -197.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.454,224.444a15.683,15.683,0,0,0-1.361-7.223,37.91,37.91,0,0,1-2.139-6.329s-.1,5.749,1.04,7.907S304.454,224.444,304.454,224.444Z",
    transform: "translate(-300.951 -197.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.23,223.229a12.547,12.547,0,0,1,4.388-1.793,10.568,10.568,0,0,0,2.728-.6,5.1,5.1,0,0,1-3.746,2.326A8.712,8.712,0,0,1,305.23,223.229Z",
    transform: "translate(-301.365 -198.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M303.612,227.283c.482-1.879,1.1-4.784,1.745-6.725a59.385,59.385,0,0,1,4.778-9.8c-2.054,4.558-3.555,7.12-4.588,11.05-.409,1.558-1.117,3.72-1.5,5.133C303.985,227.323,303.675,227.648,303.612,227.283Z",
    transform: "translate(-301.208 -197.189)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.149)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.151,218.672a29.473,29.473,0,0,0-1.708-7.816c-1.488-3.918-3.524-10.289-3.524-10.289s.6,4.243,1.7,9.182A32.965,32.965,0,0,0,304.151,218.672Z",
    transform: "translate(-296.057 -194.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.8,211.133a17.091,17.091,0,0,1-2.128-8.422c-.079-5.251-.392-9.335-.392-9.335a69.7,69.7,0,0,1,2.173,10.614C303.776,208.139,303.8,211.133,303.8,211.133Z",
    transform: "translate(-296.285 -193.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.753,217.961a62.221,62.221,0,0,1,1.548-10.209c1.179-4.363,2.132-7.029,2.132-7.029s-.809,8.373-1.381,11.851A11.254,11.254,0,0,1,304.753,217.961Z",
    transform: "translate(-296.621 -194.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.794,222.333a32.845,32.845,0,0,1,4.662-10.052,34.594,34.594,0,0,0,4.4-7.484,35.1,35.1,0,0,1-3.441,9.545A67.211,67.211,0,0,1,304.794,222.333Z",
    transform: "translate(-296.624 -194.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M303.883,221.529s-2.759-4.681-4.464-6.146a24.825,24.825,0,0,1-3.668-4.7s1.9,5.514,3.5,7.028S303.883,221.529,303.883,221.529Z",
    transform: "translate(-295.751 -195.048)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.466,227.044a16.68,16.68,0,0,1,3.867-6.789,40.276,40.276,0,0,0,4.339-5.622s-1.885,5.815-3.78,7.588S304.466,227.044,304.466,227.044Z",
    transform: "translate(-296.593 -195.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M304.219,225.291a13.373,13.373,0,0,0-3.791-3.321,11.243,11.243,0,0,1-2.537-1.541,5.425,5.425,0,0,0,2.961,3.634C303.406,225.318,304.219,225.291,304.219,225.291Z",
    transform: "translate(-295.958 -195.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M304.506,229.947c.165-2.055.545-5.19.573-7.363a63.139,63.139,0,0,0-1.412-11.508c.489,5.291,1.111,8.386.79,12.695-.127,1.707-.164,4.125-.267,5.677C304.118,229.86,304.317,230.293,304.506,229.947Z",
    transform: "translate(-296.516 -195.086)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M300.348,219.951a27.748,27.748,0,0,0-3.912-6.43c-2.524-3.029-6.285-8.073-6.285-8.073s1.835,3.59,4.326,7.646A31.015,31.015,0,0,0,300.348,219.951Z",
    transform: "translate(-290.062 -199.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M297.729,213.353a16.081,16.081,0,0,1-4.471-6.841c-1.678-4.646-3.206-8.184-3.206-8.184a65.628,65.628,0,0,1,5.181,8.777C296.79,210.7,297.729,213.353,297.729,213.353Z",
    transform: "translate(-290.052 -198.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M301.016,219.014a58.477,58.477,0,0,1-1.748-9.555c-.287-4.242-.255-6.906-.255-6.906s1.843,7.7,2.4,10.965A10.583,10.583,0,0,1,301.016,219.014Z",
    transform: "translate(-290.917 -198.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M302.608,222.715a30.883,30.883,0,0,1,1.071-10.368,32.6,32.6,0,0,0,1.622-8,33.02,33.02,0,0,1-.138,9.545A63.223,63.223,0,0,1,302.608,222.715Z",
    transform: "translate(-291.258 -198.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M300.985,222.576s-3.887-3.32-5.852-4.1a23.319,23.319,0,0,1-4.7-3.056s3.378,4.323,5.263,5.18S300.985,222.576,300.985,222.576Z",
    transform: "translate(-290.089 -199.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M303.594,227.034a15.686,15.686,0,0,1,1.361-7.224,37.924,37.924,0,0,0,2.139-6.328s.1,5.749-1.04,7.907S303.594,227.034,303.594,227.034Z",
    transform: "translate(-291.357 -199.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M302.435,225.818a12.576,12.576,0,0,0-4.388-1.793,10.554,10.554,0,0,1-2.728-.594,5.1,5.1,0,0,0,3.746,2.325A8.685,8.685,0,0,0,302.435,225.818Z",
    transform: "translate(-290.561 -200.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M304.116,229.872c-.482-1.879-1.1-4.784-1.745-6.724a59.346,59.346,0,0,0-4.778-9.8c2.054,4.557,3.555,7.12,4.588,11.05.409,1.558,1.117,3.72,1.5,5.132C303.743,229.913,304.053,230.238,304.116,229.872Z",
    transform: "translate(-290.78 -199.778)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M308.8,244.178h-10.54l-3.257-18.565h17.433Z",
    transform: "translate(-290.53 -196.49)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 49.344)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.457 6.331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M443.572,251.806l17.382,108.685,3.346-.01-13.753-108.7Z",
    transform: "translate(-296.599 -251.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M308.031,251.864,285.393,360.657l-4.508.011,17.748-108.782Z",
    transform: "translate(-280.885 -251.792)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 187.028,
    height: 8.37,
    transform: "translate(8.967)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 204.962,
    height: 5.556
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.891)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M423.438,236.571h-7.275l-7.275-46.414h5.531Z",
    transform: "translate(-385.683 -190.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M418.868,236.571H390.476L383.2,190.157h28.392Z",
    transform: "translate(-383.202 -190.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 30.862,
    height: 3.462,
    transform: "translate(6.893 45.362)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 38.912,
    height: 3.462,
    transform: "translate(37.755 45.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M404.787,217.849c.822,3.552.244,7.39-1.291,8.571s-3.447-.743-4.268-4.3-.244-7.391,1.292-8.571S403.965,214.294,404.787,217.849Z",
    transform: "translate(-384.714 -192.383)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.828 35.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M355.575,242.609h-4.027a3.375,3.375,0,0,1-3.334-2.857L346.6,229.389h13.914l-1.609,10.363A3.374,3.374,0,0,1,355.575,242.609Z",
    transform: "translate(-346.604 -229.389)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.469 1.426)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M360.318,240.553c-.146,0-.294-.005-.445-.017l-.189-.014-.15-.116a6.438,6.438,0,0,1-2.45-4.549c0-2.7,1.791-4.89,3.991-4.89a4.169,4.169,0,0,1,3.241,1.377,4.233,4.233,0,0,1,.743,3.625h0C364.529,238.9,362.812,240.553,360.318,240.553Zm-.151-1.269c2.54.08,3.343-1.867,3.644-3.539h0a3.045,3.045,0,0,0-.469-2.587,2.908,2.908,0,0,0-2.267-.924c-1.5,0-2.724,1.625-2.724,3.624A5.067,5.067,0,0,0,360.167,239.284Z",
    transform: "translate(-357.085 -230.967)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M344.769,244.7H362.4l2.813-3.114h-23.26Z",
    transform: "translate(-269.327 -195.124)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.183)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 27.076,
    height: 28.847,
    transform: "translate(39.675 4.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.935,
    height: 28.847,
    transform: "translate(66.751 4.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 20.339,
    height: 33.296,
    transform: "translate(32.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.88,
    height: 33.296,
    transform: "translate(52.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "z",
    width: 17.148,
    height: 28.847,
    transform: "translate(29.774 4.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.917,
    height: 28.847,
    transform: "translate(46.922 4.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 22.492,
    height: 23.966,
    transform: "translate(10.394 9.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.759,
    height: 23.966,
    transform: "translate(32.887 9.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 16.897,
    height: 27.662,
    transform: "translate(4.497 5.634)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.886,
    height: 27.662,
    transform: "translate(21.386 5.634)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 16.413,
    height: 23.966,
    transform: "translate(0 9.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aa",
    width: 3.252,
    height: 23.966,
    transform: "translate(16.422 9.33)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 33.281)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 142.691,
    height: 8.349,
    transform: "translate(142.691 8.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.251 8.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M73.719,155.694h9.759L76.37,166.436H73.719Z",
    transform: "translate(-72.314 -155.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 1.406,
    height: 10.743
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.357 8.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M200.428,155.694h9.759l-7.109,10.743h-2.651Z",
    transform: "translate(-199.022 -155.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 1.406,
    height: 10.743,
    transform: "translate(0)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.522 140.574)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.765 38.695)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2655.73,1915.592s-6.774-7.91-.418-12.935c0,0,4.644-2.814,8.431-2.586,0,0-5.367,9-3.63,9.9s5.255-10.464,5.255-10.464,10.567-1.025,13.966.611c0,0-9.033,7.4-7.13,7.839s11.659-6.822,11.659-6.822,9.834,1.675,9.311,7.68-3.914,7.859-5.4,7.7-10.2-3.489-10.392-2.267,5.056,5.213,8.728,5.4c0,0-6.933,7.655-11.542,5.445s-5-5.71-7.873-7.023-5.325-1.31-4.138.029,6.385,2.642,8.027,5.55,3.117,4.87-1.651,4.152-12.518-4.21-12.858-8.208Z",
    transform: "translate(-2644.279 -1899.189)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2685.647,1918.309s-26.711-1.03-32.61,6.615a19.358,19.358,0,0,1-5.318,7.472l-.627,1.706s4.629-4.884,6.286-5.18C2653.378,1928.922,2650.788,1919.45,2685.647,1918.309Z",
    transform: "translate(-2641.586 -1918.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2642.434,1945.293a16.789,16.789,0,0,0-6.132,11.826l1.04.094s1.83-7.841,5.141-10.907S2642.434,1945.293,2642.434,1945.293Z",
    transform: "translate(-2636.302 -1931.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M2574.382,1885.066s10.777-6.04,5.747-14.238c0,0-4.022-5.033-8.333-6.328,0,0,2.3,12.224,0,12.512s-1.581-13.806-1.581-13.806-11.351-5.466-15.806-5.033c0,0,7.041,11.937,4.742,11.649s-10.2-12.368-10.2-12.368-11.639-2.157-13.506,4.746,1.149,10.354,2.873,10.786,12.789.288,12.5,1.726-7.76,3.739-11.925,2.446c0,0,4.6,11.361,10.632,10.785s7.9-4.314,11.641-4.6,6.464.72,4.6,1.726-8.19.33-11.208,2.9-5.461,4.149.144,5.3,15.661.431,17.674-3.883Z",
    transform: "translate(-2534.852 -1857.135)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.906 7.222)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2546.428,1871.277s30.174,9.78,33.623,20.71a22.953,22.953,0,0,0,2.874,10.5v2.157s-3.162-7.335-4.887-8.341C2578.038,1896.3,2584.792,1886.81,2546.428,1871.277Z",
    transform: "translate(-2546.428 -1871.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2616.572,1931.1a19.936,19.936,0,0,1,2,15.682l-1.2-.323s1.163-9.483-1.272-14.251S2616.572,1931.1,2616.572,1931.1Z",
    transform: "translate(-2580.073 -1899.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M2636.959,1860.24s-14.205-7.963-7.575-18.768c0,0,5.3-6.635,10.985-8.341,0,0-3.031,16.114,0,16.493s2.084-18.2,2.084-18.2,14.962-7.2,20.835-6.634c0,0-9.281,15.734-6.25,15.355s13.448-16.3,13.448-16.3,15.343-2.843,17.8,6.256-1.515,13.65-3.787,14.218-16.858.378-16.479,2.275,10.228,4.929,15.721,3.223c0,0-6.061,14.977-14.017,14.219s-10.417-5.688-15.342-6.067-8.524.948-6.061,2.275,10.8.435,14.773,3.818,7.2,5.47-.188,6.987-20.646.569-23.3-5.118Z",
    transform: "translate(-2627.621 -1823.421)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.836 9.521)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M2686.61,1842.063s-39.776,12.891-44.323,27.3a30.275,30.275,0,0,1-3.788,13.839v2.843s4.168-9.668,6.44-10.994C2644.94,1875.05,2636.036,1862.537,2686.61,1842.063Z",
    transform: "translate(-2634.784 -1842.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2634.934,1920.918s-6.134,9.323-2.639,20.672l1.58-.425s-1.533-12.5,1.677-18.786S2634.934,1920.918,2634.934,1920.918Z",
    transform: "translate(-2631.219 -1879.781)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2618.277,1984.6a27.839,27.839,0,0,0,27.827-27.851H2590.45A27.838,27.838,0,0,0,2618.277,1984.6Z",
    transform: "translate(-2562.081 -1888.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M2628.379,1984.384a27.845,27.845,0,0,1-31.284-27.637h6.913A27.846,27.846,0,0,0,2628.379,1984.384Z",
    transform: "translate(-2565.335 -1888.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M2646.119,2010.764H2589.7a3.434,3.434,0,0,1,3.432-3.436h49.557a3.434,3.434,0,0,1,3.433,3.436Z",
    transform: "translate(-2561.712 -1913.407)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    width: 57.201,
    height: 0.854,
    transform: "translate(27.454 68.089)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M.508,0H481.66a.508.508,0,0,1,.508.508v0a.509.509,0,0,1-.509.509H.509A.509.509,0,0,1,0,.508v0A.508.508,0,0,1,.508,0Z",
    transform: "translate(0 236.965)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationOopsError);
export default __webpack_public_path__ + "static/media/illustration - Oops Error.f8ba19a8b962416f8d10ab2bbce46e65.svg";
export { ForwardRef as ReactComponent };